import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-6 px-4" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <div className="text-center mb-6" data-id="element-20">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-600 px-4 py-2 rounded-full font-bold uppercase tracking-wide mb-2" data-id="element-21">
            <Gift className="w-5 h-5" data-id="element-22" />
            Bonos Gratis Hoy
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900" data-id="element-23">
            Te llevás 2 bonos exclusivos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-24">
          {/* Bonus 1 */}
          <div className="flex flex-col items-center text-center group cursor-pointer" onClick={scrollToPricing} data-id="element-25">
            <div className="relative mb-3 w-full max-w-sm mx-auto transform group-hover:scale-105 transition-transform duration-300" data-id="element-26">
              <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg z-10" data-id="element-27">
                GRATIS POR HOY
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/6n2J7FTUJRnNoVDuGdu4mS/bonus_1_(1).png" alt="Bono 1 Planificación Anual" className="w-full h-auto rounded-lg shadow-xl" data-id="element-28" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-29">
              BONO 1 – <span className="text-green-600" data-id="element-30">GRATIS</span>
            </h3>
            <h4 className="text-xl font-bold text-gray-800 mb-2" data-id="element-31">
              📅 Planificación Anual Lista
            </h4>
            <p className="text-gray-600 text-lg" data-id="element-32">
              Organizá todo el año escolar con una planificación clara,
              adaptable y lista para presentar.
            </p>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col items-center text-center group cursor-pointer" onClick={scrollToPricing} data-id="element-33">
            <div className="relative mb-3 w-full max-w-sm mx-auto transform group-hover:scale-105 transition-transform duration-300" data-id="element-34">
              <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg z-10" data-id="element-35">
                GRATIS POR HOY
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/2g2aPV8gi2y4qLnQV3KhuC/bonus_2_(1).png" alt="Bono 2 Dinámicas Psicológicas" className="w-full h-auto rounded-lg shadow-xl" data-id="element-36" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-37">
              BONO 2 – <span className="text-green-600" data-id="element-38">GRATIS</span>
            </h3>
            <h4 className="text-xl font-bold text-gray-800 mb-2" data-id="element-39">
              🧠 Banco de Dinámicas Psicológicas para el Aula
            </h4>
            <p className="text-gray-600 text-lg" data-id="element-40">
              Mejorá la participación, generá impacto y facilitá clases más
              activas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}